import { AccountSettingsPage, AccountSettingsRoute } from './types';

export const reduxKey = '@@AccountSettings';

export const pageInfoByPageEnum: Record<
  AccountSettingsPage,
  {
    route: AccountSettingsRoute;
    biComponent: string;
    page: AccountSettingsPage;
    title: string;
  }
> = {
  [AccountSettingsPage.MyAccount]: {
    route: AccountSettingsRoute.General,
    biComponent: 'general',
    page: AccountSettingsPage.MyAccount,
    title: 'My account',
  },
  [AccountSettingsPage.Browsing]: {
    route: AccountSettingsRoute.Browsing,
    biComponent: 'browsing',
    page: AccountSettingsPage.Browsing,
    title: 'Browsing',
  },
  [AccountSettingsPage.Security]: {
    route: AccountSettingsRoute.Security,
    biComponent: 'auth',
    page: AccountSettingsPage.Security,
    title: 'Security & privacy',
  },
  [AccountSettingsPage.Notifications]: {
    route: AccountSettingsRoute.Notifications,
    biComponent: 'notifications',
    page: AccountSettingsPage.Notifications,
    title: 'Notifications',
  },
  [AccountSettingsPage.Promos]: {
    route: AccountSettingsRoute.Promos,
    biComponent: 'promos',
    page: AccountSettingsPage.Promos,
    title: 'Promotional banners',
  },
  [AccountSettingsPage.PersonalData]: {
    route: AccountSettingsRoute.PersonalData,
    biComponent: 'personaldata',
    page: AccountSettingsPage.PersonalData,
    title: 'Personal Data',
  },
  [AccountSettingsPage.Deactivation]: {
    route: AccountSettingsRoute.Deactivation,
    biComponent: 'deactivation',
    page: AccountSettingsPage.Deactivation,
    title: 'Deactivation',
  },
};
